import http from "../services/httpServices";
import React, { useContext, useEffect, useState, useRef } from "react";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { toast } from "react-toastify";
import utils from "../services/utilsServices";
import cardService from "../services/cardServices";
import { MainContext } from "../store/mainContext";
import { Link } from 'react-router-dom';
export default function AddUser({ show, handleClose }) {
    const { defaultDevice, setDefaultDevice } = useContext(MainContext);
    useEffect(() => {
        getUsers()
    }, []);

    const [list, setList] = useState([])

    const getUsers = () => {
        const temp = cardService.getUsers()
        setList(temp);
        return temp;
    }

    const deleteItem = (e, x) => {
        e.preventDefault();
        e.stopPropagation()
        cardService.deleteUser(x.id);
        getUsers();
         utils.sendSms(defaultDevice.deviceNumber, `del,${x.userNumber}`);
        toast.success(utils.waitSms);
    }

    const [form, setForm] = useState({ userNumber: "" })
    const formRef = useRef(null);

    const [isPosting, setIsPosting] = useState(false)
    const doPost = async (e) => {
        e.preventDefault();
        e.stopPropagation()
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error(utils.checkInput, { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        const temp = utils.checkNumber(form.userNumber); 
        cardService.addUser([{
            userNumber: temp,
            id: (new Date()).getTime(),
        }]);
        utils.sendSms(defaultDevice.deviceNumber, `add,${temp}`);
        toast.success(utils.waitSms);
        handleClose(e, form)
    }

    return (
        <>
            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="bottom"
                className="customBottomCanvas "  >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title className="w-100 d-flex justify-content-center">  افزودن کاربر</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {list.map((x, i) => (
                        <div className="row rounded border bg-secondary-subtle p-2 mb-3" key={"l" + i}>
                            <div
                                className="col ">                              
                                {x.userNumber}
                            </div>
                            <div className="col-auto">
                                <Link onClick={(e) => { deleteItem(e, x) }}>❌</Link>
                            </div>
                        </div>
                    ))}
                    <form ref={formRef} className=" needs-validation" >

                        <div className="form-floating mb-3">
                            <input
                                type="number"
                                className="form-control"
                                name="userNumber"
                                value={form.userNumber}
                                onChange={e => http.handleChange(e, form, setForm)}
                                placeholder=" "
                                required />
                            <label htmlFor="floatingInput">موبایل کاربر (09123456789)</label>
                        </div>
                        <div className='row mt-3 '>
                            <div className='col'>
                                <button className='btn btn-warning w-100'
                                    disabled={isPosting}
                                    onClick={doPost}>تایید
                                    {isPosting &&
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    }
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>

    );

}
